import l, { useState as P, useEffect as a, useRef as E, useCallback as R } from "react";
import { useFormContext as S } from "react-hook-form";
import "intl-tel-input/build/css/intlTelInput.css";
import { TextInput as w } from "../TextInput/TextInput.js";
import { isBrowser as x } from "../../../../../utils.js";
function j(p) {
  const {
    onChange: n,
    value: s,
    defaultValue: m,
    intlTelInput: f,
    utilsScript: I,
    formOptions: N,
    name: i,
    ...V
  } = p, u = S(), d = u && i, c = d ? u.watch(i) : void 0, o = E(null), r = E(), C = {
    validate: () => {
      var t;
      return ((t = r.current) == null ? void 0 : t.isValidNumber()) ?? !1;
    },
    ...N
  }, g = async (t) => {
    var y, v;
    const e = ((y = r.current) == null ? void 0 : y.isValidNumber()) ?? !1, b = ((v = r.current) == null ? void 0 : v.getNumber()) ?? "";
    u && i && (u.setValue(i, b), await u.trigger()), n == null || n(t, b, e);
  }, h = R((t) => {
    g(t);
  }, []);
  return a(() => o.current === null ? () => {
  } : (r.current = f(o.current, {
    preferredCountries: ["es", "gb", "pt", "fr", "it", "de", "nl", "us", "ru", "cn", "jp"],
    utilsScript: I,
    geoIpLookup(t) {
      fetch("https://ipapi.co/json").then((e) => e.json()).then((e) => {
        t(e.country_code);
      }).catch(() => {
        t("es");
      });
    }
  }), o.current.addEventListener("countrychange", h), () => {
    var t, e;
    (t = r.current) == null || t.destroy(), (e = o.current) == null || e.removeEventListener("countrychange", h);
  }), []), a(() => {
    var e;
    if (d) return;
    const t = s ?? m;
    (e = r.current) == null || e.setNumber((t == null ? void 0 : t.toString()) ?? "");
  }, [s]), a(() => {
    var t, e;
    d && ((t = r.current) == null || t.setNumber((c == null ? void 0 : c.toString()) ?? ""), (e = r.current) != null && e.isValidNumber() && u.setValue(i, r.current.getNumber()));
  }, [c]), /* @__PURE__ */ l.createElement(
    w,
    {
      name: i,
      ref: o,
      formOptions: C,
      customChangeHandler: g,
      type: "text",
      skipRHFValue: !0,
      ...V
    }
  );
}
function T(p) {
  const [n, s] = P(null);
  return a(() => {
    (async () => {
      if (!x())
        return;
      const [
        { default: m },
        { default: f }
      ] = await Promise.all([
        import("intl-tel-input"),
        // @ts-ignore
        import("intl-tel-input/build/js/utils")
      ]);
      s({
        initializer: m,
        utils: f
      });
    })();
  }, []), n === null ? /* @__PURE__ */ l.createElement("div", { "data-testid": "phone-input" }, "loading...") : /* @__PURE__ */ l.createElement("div", { "data-testid": "phone-input" }, /* @__PURE__ */ l.createElement(
    j,
    {
      ...p,
      utilsScript: n.utils,
      intlTelInput: n.initializer
    }
  ));
}
export {
  T as PhoneInput,
  j as PhoneInputRoot
};
//# sourceMappingURL=PhoneInput.js.map
